<template>
  <div>
     <!--====== PRELOADER PART START ======-->

    <!-- <div class="loader-wrap">
        <div class="preloader"><div class="preloader-close">Preloader Close</div></div>
        <div class="layer layer-one"><span class="overlay"></span></div>
        <div class="layer layer-two"><span class="overlay"></span></div>        
        <div class="layer layer-three"><span class="overlay"></span></div>        
    </div> -->

    <!--====== PRELOADER PART ENDS ======-->

    <!--====== OFFCANVAS MENU PART START ======-->

   <sidebar-home-one :sidebar="sidebar" @toggleSidebar="toggleSidebar" :menuItems="navs" />

    <!--====== OFFCANVAS MENU PART ENDS ======-->
   
    <!--====== PART START ======-->
    
    <header-news  @toggleSidebar="toggleSidebar" :menuItems="navs"/>
    <!--====== PART ENDS ======-->

    <!--====== APPIE PAGE TITLE PART START ======-->
    
    <banner-service-details/>
    
    <!--====== APPIE PAGE TITLE PART ENDS ======-->

    <!--====== APPIE SERVICE DETAILS PART ENDS ======-->

    <section class="appie-service-details-area pt-100 pb-100">
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                   <body-nav-sidebar/>
                </div>
                <div class="col-lg-8">
                    <div class="service-details-content">
                        <div class="thumb">
                            <img src="assets/images/service-details-thumb.jpg" alt="">
                        </div>
                        <div class="content">
                            <h3 class="title">Why Use TroFii?</h3>
                            <p>Find your next dining spot with TroFii. Explore food photo reviews for menu units in nearby restaurants. Then order takeout, food delivery or book reservations. </p>
                            <span>
                                Are you looking for a food reviews app so you can find the best restaurants nearby?<br>
                                Do you want to view picture food menus of individual menu items from many amazing restaurants nearby?
                                </span>
                            <p>
                                1. FIRST AND ONLY PICTURE MENU <br>
                                With photo food reviews by real users for individual menu units.<br><br>
                                2. DISCOVER DISHES NOT RESTAURANTS<br>
                                Find recommended dishes with photo reviews.<br><br>
                                3. REVIEW DISHES<br>
                                Add photo reviews and earn $1 egifts for each approved photo<br><br>
                                4.  FIND THE BEST FOOD <br>
                                Discover the best restaurants and food nearby<br><br>
                                5. ORDER OR DINE OUT<br>
                                Order food delivery, takeout, or book reservations using the restaurant info on TroFii<br><br>
                                6. YOUR FOODIE DIARY<br>
                                Add as many photo reviews as possible, share your food reviews and create your photo diary.<br><br>
                                </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!--====== APPIE SERVICE DETAILS PART ENDS ======-->

    <!--====== APPIE PROJECT PART START ======-->
    
    <project-home-one title="Start your project with appie." description="We will email you only about this product."/>
    
    <!--====== APPIE PROJECT PART ENDS ======-->

    <!--====== APPIE FOOTER PART START ======-->
    
    <footer-home-one/>
    
    <!--====== APPIE FOOTER PART ENDS ======-->


    <!--====== APPIE BACK TO TOP PART ENDS ======-->
    <div class="back-to-top">
        <a href="#"><i class="fal fa-arrow-up"></i></a>
    </div>
    <!--====== APPIE BACK TO TOP PART ENDS ======-->
  </div>
</template>

<script>
import FooterHomeOne from '../HomeOne/FooterHomeOne.vue';
// import ProjectHomeOne from '../HomeOne/ProjectHomeOne.vue';
import SidebarHomeOne from '../HomeOne/SidebarHomeOne.vue';
import HeaderNews from '../News/HeaderNews.vue';
import BannerServiceDetails from './BannerServiceDetails.vue';
import BodyNavSidebar from './BodyNavSidebar.vue';
export default {
	components: { SidebarHomeOne, HeaderNews, BannerServiceDetails, BodyNavSidebar, FooterHomeOne },
  data(){
        return{
            sidebar:false,
            showloading:true,
              navs:[
            {
                name:'Home',
                path:'/'
            },
            {
                name:'About us',
                path:'/about-us'
            },
            {
                name:'Features',
                path:'/service-details'
            },
            {
                name:'Support',
                path:'/contact'
            }
            ]
        }
    },
      mounted() {
        document.addEventListener('scroll', this.topToBottom)
    },
    methods: {
       topToBottom(){
        const result = document.querySelector('.back-to-top')
           if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight ) {
                result.style.display = "block";
            } else {
                result.style.display = "none";
            }
        },
        toggleSidebar(){
           this.sidebar = !this.sidebar
        },   
    }

}
</script>

<style>

</style>